import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  connect() {
    // Ensure first tab is active on connect
    this.showTab(this.tabTargets[0]?.dataset.tab || 'seo')
  }

  select(event) {
    const tabName = event.currentTarget.dataset.tab
    this.showTab(tabName)
  }

  showTab(tabName) {
    // Update tab active states
    this.tabTargets.forEach((tab) => {
      if (tab.dataset.tab === tabName) {
        tab.classList.add('active')
      } else {
        tab.classList.remove('active')
      }
    })

    // Update panel visibility
    this.panelTargets.forEach((panel) => {
      if (panel.dataset.tab === tabName) {
        panel.classList.remove('hidden')
      } else {
        panel.classList.add('hidden')
      }
    })
  }
}
